module.exports = __webpack_public_path__ + "workspace/static/img/usageReportOne.01b7939.png";